import * as React from "react";
import { Grid } from "@mui/material";
import { snakeCaseToTitleCaseSingularize } from "../../utils/CaseFormatHelper";

interface Props {
  provider: any;
}

const ProviderDetails: React.FC<Props> = ({ provider }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={3} className="patient-info-left-container">
        <div className="detail-container">
          <h4 className="detail-header">Overview</h4>
          {provider?.career && (
            <p className="detail-text">
              Career: {snakeCaseToTitleCaseSingularize(provider?.career)}
            </p>
          )}
          {provider?.creds && (
            <p className="detail-text">Credentials: {provider?.creds}</p>
          )}
        </div>
      </Grid>
      <Grid item xs={4.5} className="patient-info-left-container">
        <div className="detail-container">
          <h4 className="detail-header">Additional Info</h4>
          {provider?.id_number && (
            <p className="detail-text">
              Rendering Provider ID #: {provider?.id_number}
            </p>
          )}
          {provider?.provider_npi_number && (
            <p className="detail-text">
              Provider NPI #: {provider?.provider_npi_number}
            </p>
          )}
          {provider?.id_qualifier && (
            <p className="detail-text">
              ID Qualifier: {provider?.id_qualifier}
            </p>
          )}
        </div>
      </Grid>
      <Grid item xs={4} className="patient-info-left-container">
        <div className="detail-container">
          <h4 className="detail-header">Contact</h4>
          {provider?.email && <p className="detail-text">{provider?.email}</p>}
          {provider?.mobile_phone_number && (
            <p className="detail-text">{provider?.mobile_phone_number}</p>
          )}
          {provider?.business_phone_number && (
            <p className="detail-text">{provider?.business_phone_number}</p>
          )}
        </div>
      </Grid>
    </Grid>
  );
};

export default ProviderDetails;
